{
  "title": "Rope Trick",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level transmutation",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (powdered corn extract and a twisted loop of parchment)",
  "duration": "1 hour",
  "description": [
    "You touch a length of rope that is up to 60 feet long. One end of the rope then rises into the air until the whole rope hangs perpendicular to the ground. At the upper end of the rope, an invisible entrance opens to an extradimensional space that lasts until the spell ends.",
    "The extradimensional space can be reached by climbing to the top of the rope. The space can hold as many as eight Medium or smaller creatures. The rope can be pulled into the space, making the rope disappear from view outside the space.",
    "Attacks and spells can’t cross through the entrance into or out of the extradimensional space, but those inside can see out of it as if through a 3-foot-by-5-foot window centered on the rope.",
    "Anything inside the extradimensional space drops out when the spell ends."
  ],
  "spellLists": ["artificer", "wizard"]
}
